// Environment configuration
import prodPublicEnv from './prod-public-env.json';

// Local dev (`npm start`, NODE_ENV !== 'production') still shares the prod
// Supabase project until a dedicated dev project is split out (#651), so it may
// fall back to the prod values. A PRODUCTION build (prod OR staging — both are
// `npm run build`, NODE_ENV === 'production') must NEVER silently fall back to
// prod: it uses its own REACT_APP_* env vars, and the build-time guard
// (scripts/check-build-env.js, Plan 227 Task 2.8) fails the build if a non-prod
// build is missing them or points them at prod. The empty-string fallback here
// is a last resort that breaks visibly rather than leaking prod into a bundle.
// The prod values come from the shared prod-public-env.json that the build guard
// also reads, so the two cannot drift.
const isLocalDev = process.env.NODE_ENV !== 'production';
const LOCAL_DEV_SUPABASE_URL = prodPublicEnv.supabaseUrl;
const LOCAL_DEV_SUPABASE_ANON_KEY = prodPublicEnv.supabaseAnonKey;

export const config = {
  // API Configuration
  // In development, use empty string to route through CRA proxy (same-origin, no CORS preflights).
  // This prevents browser connection exhaustion from OPTIONS preflight doubling request count.
  // WebSocket connections still go directly to port 8000 via WS_BASE_URL.
  apiUrl: process.env.REACT_APP_API_URL || '',

  // Supabase Configuration
  supabaseUrl: process.env.REACT_APP_SUPABASE_URL || (isLocalDev ? LOCAL_DEV_SUPABASE_URL : ''),
  supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || (isLocalDev ? LOCAL_DEV_SUPABASE_ANON_KEY : ''),

  // Application Configuration
  appName: 'Glyphe',
  appVersion: '1.0.0',
  
  // File Upload Configuration
  maxFileSize: 100 * 1024 * 1024, // 100MB
  allowedFileTypes: ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  allowedFileExtensions: ['.pdf', '.docx'],
  
  // UI Configuration
  itemsPerPage: 10,
  pollInterval: 2000, // 2 seconds for status polling
};

// Validate required environment variables
export const validateConfig = () => {
  const requiredVars = [
    'REACT_APP_SUPABASE_URL',
    'REACT_APP_SUPABASE_ANON_KEY'
  ];
  
  const missing = requiredVars.filter(varName => !process.env[varName]);
  
  if (missing.length > 0) {
    console.warn('Missing environment variables:', missing);
    console.warn('Using default values. Please check your .env file.');
  }
};